import * as React from "react";

function SvgMadKudu(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 136.2 90.8"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M52.2 90.3c-1.8-6.2-6.5-11.4-11.6-15.2-6.9-4.9-15.8-3.9-23.4-6.7-6.2-4.6-.3-9.7 3.9-12.8 9.3-8.1 8.1-23.1.8-32C17 17.2 6.5 13 1.4 11.1-6.4 3.4 22-3.4 12.7 1.9c-3.2 1.4-6.4 3.9-.6 5.4 6.9 2.1 23.1 15.4 25 28.5 1.4 7-.5 14.9-3.1 21.4 16.9 5.3 24.2 17.4 32.2 32.9-.1 0-3.8.3-14 .2zM83.9 90.8c1.8-6.2 6.5-11.4 11.6-15.2 6.9-4.9 15.8-3.9 23.4-6.7 6.2-4.6.3-9.7-3.9-12.8-9.3-8.1-8.1-23.1-.8-32 4.9-6.4 15.4-10.7 20.5-12.5C142.5 3.8 114-3 123.4 2.3c3.2 1.4 6.4 3.9.6 5.4-6.9 2.1-23.1 15.4-25 28.5-1.4 7 .5 14.9 3.1 21.4-16.8 5.5-24 17.5-32.1 33.1 0-.1 3.8.2 13.9.1z" />
    </svg>
  );
}

export default React.forwardRef(SvgMadKudu);
